import { useCallback, useEffect, useState } from 'react'

import { Form } from 'react-bootstrap'
import ReactSelect from 'react-select'
import { toast } from 'react-toastify'
import { CheckCircleFill } from 'react-bootstrap-icons'

import { Modable } from '../../../../components/Modable'
import { CustomButton } from '../../../../components/CustomButton'

import SubcategoriesService from '../../../../services/database/SubcategoriesService'

import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'

import { Container, Footer } from './styles'
import CategoriesService from '../../../../services/database/CategoriesService'

export function ModalUpdate({
  isOpen,
  onClose,
  subcategoryId,
  loadSubcategories,
}) {
  const [subcategory, setSubcategory] = useState({
    id_subcategoria: '',
    subcategoria: '',
    id_categoria: {
      value: '',
      label: '',
    },
  })
  const [categories, setCategories] = useState([])
  const [isCategoriesLoading, setIsCategoriesLoading] = useState(true)
  const [isLoadingSubcategory, setIsLoadingSubcategory] = useState(false)
  const [isUpdateRequestLoading, setIsUpdateRequestLoading] = useState(false)

  const optionsCategories = categories.map((category) => ({
    label: category.categoria,
    value: category.id_categoria,
  }))

  const getSubcategoryById = useCallback(async () => {
    try {
      setIsLoadingSubcategory(true)

      const data = await SubcategoriesService.getById(subcategoryId)

      setSubcategory({
        ...data,
        id_categoria: {
          value: data.id_categoria,
          label: data.categoria,
        },
      })
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar a subcategoria!')
    } finally {
      setIsLoadingSubcategory(false)
    }
  }, [subcategoryId])

  async function loadCategories() {
    try {
      setIsCategoriesLoading(true)

      const data = await CategoriesService.getAll()

      setCategories(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao carregar as categorias!')
    } finally {
      setIsCategoriesLoading(false)
    }
  }

  async function handleUpdateSubcategory() {
    try {
      setIsUpdateRequestLoading(true)

      await SubcategoriesService.update(subcategory.id_subcategoria, {
        name: subcategory.subcategoria,
        categoryId: subcategory.id_categoria,
      })

      loadSubcategories()
      toast.success('Subcategoria atualizada com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao atualizar a subcategoria!')
    } finally {
      setIsUpdateRequestLoading(false)
      onClose()
    }
  }

  useEffect(() => {
    loadCategories()
    getSubcategoryById()
  }, [getSubcategoryById])

  return (
    <Modable
      isOpen={isOpen}
      onClose={onClose}
      size="medium"
    >
      <Container>
        <div>
          <h1>Editar Subcategoria</h1>

          <Form.Control
            name="subcategoria"
            value={subcategory.subcategoria}
            disabled={isLoadingSubcategory}
            onChange={(e) =>
              setSubcategory((prevState) => ({
                ...prevState,
                subcategoria: e.target.value,
              }))
            }
            placeholder={
              isLoadingSubcategory ? 'Carregando...' : 'Digite o nome...'
            }
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                if (e.target.value) {
                  handleUpdateSubcategory()
                }
              }
            }}
            style={{
              marginBottom: 10,
            }}
          />

          <ReactSelect
            name="id_categoria"
            value={subcategory.id_categoria}
            onChange={(option) =>
              setSubcategory((prevState) => ({
                ...prevState,
                id_categoria: option,
              }))
            }
            placeholder="Selecione a categoria"
            options={optionsCategories}
            isDisabled={isCategoriesLoading}
            isLoading={isCategoriesLoading}
          />
        </div>

        <Footer>
          <CustomButton
            title="Atualizar"
            color="#0d9a04"
            onClick={handleUpdateSubcategory}
            isLoading={isUpdateRequestLoading}
            isLoadingText="Atualizando..."
          >
            <CheckCircleFill />
          </CustomButton>
        </Footer>
      </Container>
    </Modable>
  )
}
